import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {DossierService} from "../../../../../services";
import {FormControl, Validators} from "@angular/forms";
import {Unsubscribable} from "rxjs";
import {DictionaryService} from "@amlCore/services";
import {TypeOrg} from "../../../../../models/dossier";
import {DossierBaseModel} from "../../dossierBaseModel";
import {DossierBaseSubComponent} from "../dossierBaseSub.component";
import {AlertPanelService} from "@amlCore/components";
import {DossierAccessEnum} from "@amlCore/enums";
import {delay} from "rxjs/operators";

@Component({
  selector: 'app-reg-info-dossier',
  styleUrls: ['../../dossier.css'],
  templateUrl: './regInfoDossier.component.html'
})
export class RegInfoDossierComponent extends DossierBaseSubComponent implements OnInit, OnDestroy{
  // TODO не очень хорошо передавать контрол формы через @Input() в такой реализации.
  //  Это приводит к ошибкам вида "ExpressionChangedAfterItHasBeenCheckedError"
  //  Если это исправить, то уже не надо будет использовать setTimeOut() или delay.
  @Input() rezidentRf: FormControl;
  @Input() typeOrg: TypeOrg;
  rezidentRfSub: Unsubscribable;
  formGroupValueChangesSub: Unsubscribable;
  ogrnLength = 13;
  dossierAccessEnum = DossierAccessEnum;

  constructor(protected dossierService: DossierService,
              protected dictSrv: DictionaryService,
              protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  ngOnInit(): void {
    setTimeout( () => {
      this.initFields();
      this.rezidentRfSub = this.rezidentRf.valueChanges.pipe(delay(0)).subscribe(() => {
        this.initFields();
      });
      this.addUnsubscribable(this.rezidentRfSub);
    });
    // TODO странное использование таких значений typeOrg, у нас в системе везде значения из ClientTypeEnum
    this.ogrnLength = this.typeOrg === 'ul' ? 13 : 15;
  }

  initFields(): void {
    const isRezidentRf = this.rezidentRf.value;
    if (!this.formGroupApp.disabled) {
      const ogrn = this.f('ogrn') as FormControl; // ОГРН
      const dateReg = this.f('dateReg') as FormControl; // Дата государственной регистрации
      const regNum = this.f('regNum') as FormControl; // Регистрационный номер
      const dateRegIn = this.f('dateRegIn') as FormControl; // Дата регистрации

      if (isRezidentRf) {
        this.enableControls(ogrn, dateReg);
        this.disableControls(regNum, dateRegIn);
      } else {
        this.enableControls(regNum, dateRegIn);
        this.disableControls(ogrn, dateReg);
      }
      this.formGroupApp.updateValueAndValidity();
    }
  }

  getTitleGosReg(): string {
    return this.typeOrg === 'ul' ? 'Данные о государственной регистрации (для российских юридических лиц)'
      : 'Данные о государственной регистрации';
  }

  ngOnDestroy(): void {
    this.unsubscribable();
  }

}
